import { Module } from 'vuex-smart-module';
import DetailPages from '@/modules/projects/store/modules/detail-pages';
import ProjectsActions from './actions';
import ProjectsGetters from './getters';
import ProjectsMutations from './mutaitons';
import ProjectsState from './state';

export default new Module({
  state: ProjectsState,
  mutations: ProjectsMutations,
  actions: ProjectsActions,
  getters: ProjectsGetters,
  modules: {
    detail_pages: DetailPages,
  },
});
